module.exports = __webpack_public_path__ + "static/media/ssangyong_logo-01.313bd2db.png";